module.exports = __webpack_public_path__ + "static/media/nav-close-yellow.cf57e124.svg";